var options = {};

options = {
  sing: "Daten Import",
  plu: "Daten Import",
}

export default options;